import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

import { FaSignInAlt } from 'react-icons/fa'

import { CustomEventPicker } from '../components/CustomPickers'
import { EventDetailsDisplay } from '../components/CustomDisplay'
import { GenericTable } from '../components/Utils'
import ReservationsFinder from '../components/Admin/CustomAdminComponents/ReservationsFinder'

import {
    NOT_CHOOSEN_STATE, ID_FIELD, NAME_FIELD, NUMBER_FIELD, MAIL_FIELD
} from '../constants'

import {
    CHOOSE_AN_OPTION_TEXT, RESERVATIONS_HEADER, LOGOUT_TEXT
} from '../strings'

import {parseEvents, validateField} from '../utils'


class Reservations extends Component {

    constructor(props){
        super(props)

        this.state = {
            reservations: {},
            events: {},
            selectedEventId: null,
            reservationToFind: {
                name: '',
                phone: '',
                mail: '',
                id: '',
                selectedTime: 0
            },
            errorMessages: {
                invalidName: false,
                invalidPhone: false,
                invalidMail: false,
                invalidId: false
            },
            reservationsState: NOT_CHOOSEN_STATE,
            selectedReservationsIds: []
        }
        this.dbRef = null

        this.onCheckIn = this.onCheckIn.bind(this)
        this.reservationsHeaders = [
            {name: 'Id', small: true},
            {name: 'Nombre', small: false},
            {name: 'Teléfono', small: true},
            {name: 'Correo', small: false},
            {name: 'Invitados', small: false, render: 'list'},
            {name: 'Hora', small: true, render: 'time'},
            {name: 'Productos', small: true, render: 'list'},
            {name: 'Silla de ruedas', small: true},
            {name: 'CheckIn', small: true, render: 'checkBox', func: this.onCheckIn}
        ]
        this.handleLogout = this.handleLogout.bind(this)
        this.handleEventChange = this.handleEventChange.bind(this)
        this.handleReservationSearchDataChange = this.handleReservationSearchDataChange.bind(this)
        this.getReservationsTableData = this.getReservationsTableData.bind(this)
    }


    handleLogout(){
        localStorage.clear()
        this.props.history.push('/login')
    }

    handleEventChange(event){
        const {selectedEventId} = this.state
        const eventId = event.target.value
        if (this.dbRef && selectedEventId !== eventId){
            // Unsubscribe to previous reservations
            this.dbRef.off('value')
        }
        if (eventId === CHOOSE_AN_OPTION_TEXT){
            this.setState({
                selectedEventId: null
            })
            return
        }
        this.dbRef = Firebase.database().ref(`/guests/${eventId}`)

        this.dbRef.on('value', snapshot => {
            var reservations = snapshot.val()
            if (reservations === null){
                reservations = {}
            }
            this.setState({
                reservations: reservations
            })
        })
        this.setState({
            selectedEventId: eventId
        })
    }

    onCheckIn(rowIndex){
        const {reservations, selectedEventId} = this.state
        const {getReservationsTableData} = this
        const tableData = getReservationsTableData()
        const resId = tableData[rowIndex][0]
        const checkIn = reservations[resId].checkIn
        Firebase.database().ref(`/guests/${selectedEventId}/${resId}/checkIn`).set(!checkIn)
    }

    handleReservationSearchDataChange(eventType, value){
        const {reservationToFind, errorMessages} = this.state
        if (eventType === 'id'){
            const newReservationId = value.trim()
            if (newReservationId.length > 9){
                return
            }
            if (!validateField(ID_FIELD, newReservationId) && newReservationId.length > 0){
                errorMessages.invalidId = true
            } else {
                errorMessages.invalidId = false
            }
            reservationToFind.id = newReservationId
        } else if (eventType === 'name'){
            if (value.length > 30){
                return
            }
            if (!validateField(NAME_FIELD, value) && value.length > 0){
                errorMessages.invalidName = true
            } else {
                errorMessages.invalidName = false
            }
            reservationToFind.name = value
        } else if (eventType === 'phone'){
            const newPhone = value.trim().replace('-', '')
            if (newPhone.length > 8){
                return
            }
            if (!validateField(NUMBER_FIELD, newPhone) && newPhone.length > 0){
                errorMessages.invalidPhone = true
            } else {
                errorMessages.invalidPhone = false
            }
            reservationToFind.phone = newPhone
        } else if (eventType === 'mail'){
            const newMail = value.trim()
            if (!validateField(MAIL_FIELD, newMail) && newMail.length > 0){
                errorMessages.invalidMail = true
            } else {
                errorMessages.invalidMail = false
            }
            reservationToFind.mail = newMail
        } else if (eventType === 'time'){
            reservationToFind.selectedTime = value === '**Todas' ? null : Number(value)
        }
        this.setState({
            reservationToFind: reservationToFind,
            errorMessages: errorMessages
        })

    }

    getReservationsTableData(){
        const {reservationToFind, reservations, errorMessages} = this.state
        const result = []
        if (
            errorMessages.invalidName ||
            errorMessages.invalidMail ||
            errorMessages.invalidPhone ||
            errorMessages.invalidId
        ){
            return result
        }
        // Filter reservations and return
        for (var reservationId in reservations){
            const reservation = reservations[reservationId]
            if (reservationToFind.id && reservationId !== reservationToFind.id){
                continue
            }
            if (
                reservationToFind.name &&
                !reservation.personalData.name.toLowerCase().includes(
                    reservationToFind.name.toLowerCase()
                )
            ){
                continue
            }
            if (
                reservationToFind.phone &&
                reservation.personalData.phone !== reservationToFind.phone
            ){
                continue
            }
            if (
                reservationToFind.mail &&
                reservation.personalData.mail !== reservationToFind.mail
            ){
                continue
            }
            if (
                reservationToFind.selectedTime &&
                reservation.selectedTime !== reservationToFind.selectedTime
            ){
                continue
            }
            // If we reach this point, then add the reservation
            const guests = reservation.guests.map(el => el.name).filter(
                el => el.length > 0
            )
            const products = reservation.products ? reservation.products.map(el => el.name) : []
            var total = 0
            for (var product in reservation.products){
                total += reservation.products[product].value
            }
            products.push(`Total: ₡ ${total}`)
            const wheelChair = reservation.wheelChair ? 'Si': 'No'
            const reservationRow = [
                reservationId,
                reservation.personalData.name,
                reservation.personalData.phone,
                reservation.personalData.mail,
                guests.join(','),
                reservation.selectedTime,
                products.join(','),
                wheelChair,
                reservation.checkIn
            ]
            result.push(reservationRow)
        }
        return result
    }

    componentDidMount(){
        // Get all events
        const ref = Firebase.database().ref('/events')

        ref.orderByChild('end').startAt(new Date().getTime()).on('value', snapshot => {
            var eventsRaw = snapshot.val()
            if (eventsRaw === null){
                eventsRaw = {}
            }
            const availableEvents = parseEvents(eventsRaw, false)
            this.setState({
                events: availableEvents
            })
        })
    }

    render(){
        const {
            events, selectedEventId, reservationToFind, errorMessages
        } = this.state
        const {
            handleLogout,
            handleEventChange,
            handleReservationSearchDataChange,
            getReservationsTableData,
            reservationsHeaders
        } = this
        return(
            <div>
                <div class="topnav">
                    <label>{RESERVATIONS_HEADER}</label>
                    <label type="button" className={"inactive"} onClick={handleLogout} >
                        <FaSignInAlt/>{LOGOUT_TEXT}
                    </label>
                </div>
                <div className="registerForm">
                    <div className="reservations-header-container">
                        <CustomEventPicker
                            events={events}
                            selectedEventId={selectedEventId}
                            onEventSelected={handleEventChange}
                            disabled={false}
                        />
                        {
                            selectedEventId ?
                            <div>
                                <EventDetailsDisplay
                                    events={events}
                                    selectedEventId={selectedEventId}
                                />
                            </div> : <div></div>
                        }
                    </div>
                    <div className="shadow-box"></div>
                    {
                        selectedEventId ?
                        <div>
                            <div className="reservation-finder-container">
                                <ReservationsFinder
                                    reservationData={reservationToFind}
                                    availableHours={events[selectedEventId].availableHours}
                                    errorMessages={errorMessages}
                                    onDataChange={handleReservationSearchDataChange}
                                    isSearchComplete={false}
                                />
                            </div>
                            <div>
                                <GenericTable
                                    tableData={getReservationsTableData()}
                                    columnOrderIndex={5}
                                    headers={reservationsHeaders}
                                />
                            </div>
                        </div>: <div></div>
                    }
                </div>
            </div>
        )
    }
}

export default Reservations
